import api from './api';

const uploadService = {
  uploadImage: async (file: File, folder: string = 'trails'): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/upload/image?folder=${folder}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.url;
  },
};

export default uploadService;
